import { jsx as n } from "react/jsx-runtime";
import { createContext as a, useState as c, useEffect as g, useContext as m } from "react";
import { HISTORY_ACTION_TYPE as u } from "../types/navigation-types.js";
import f from "../events/event-aggregator.js";
import { EVENT as v } from "../events/event.js";
const e = a({
  isNavigatingBack: !1
}), I = ({ children: t }) => {
  const [i, r] = c(!1), s = (o) => {
    r(o === u.POP);
  };
  return g(() => {
    const o = f.subscribe(v.HISTORY_ACTION, s);
    return () => {
      o.remove();
    };
  }, []), /* @__PURE__ */ n(
    e.Provider,
    {
      value: {
        isNavigatingBack: i
      },
      children: t
    }
  );
}, T = () => {
  const { isNavigatingBack: t } = m(e);
  return t;
};
export {
  e as GlobalContext,
  I as GlobalContextProvider,
  T as useIsNavigatingBack
};
